import ICONS from '@/common-utils/enums/icons';

const SSL_PARAMETERS = {
    SSLv3: { name: 'SSLv3', entity: 'SSLv3', icon: ICONS.WARNING },
    'TLSv1.2': { name: 'TLSv1.2', entity: 'TLSv1.2', icon: ICONS.SECURITY }
};

export default SSL_PARAMETERS;